import script from "./Overview.vue?vue&type=script&setup=true&lang=js"
export * from "./Overview.vue?vue&type=script&setup=true&lang=js"

import "./Overview.vue?vue&type=style&index=0&id=24ea5444&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24ea5444"]])

export default __exports__